import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import axios from "axios";
import { useTranslation } from "react-i18next";

function sendResetPasswordRequest(mail, props) {
  const url =
    process.env.REACT_APP_SOPHYAPP_API_URL +
    `/de/react/0000/account/reset_password`;
  var params = new FormData();
  params.append("email", mail);
  params.append("style", props.application);
  axios
    .post(url, params)
    .then(function () {
      props.setPasswordSuccess(true);
    })
    .catch(function () {
      props.setPasswordFailed(true);
    });
}

function ResetPasswordModal(props) {
  const [mail, setMail] = useState("");
  const { t } = useTranslation();

  const handleSubmit = (event) => {
    event.preventDefault();
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.stopPropagation();
    }
    sendResetPasswordRequest(mail, props);
    props.onHide();
  };

  return (
    <Modal
      {...props}
      className="lv2-auth-modal"
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Form onSubmit={handleSubmit}>
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            {t("password.forgot")}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
            <Form.Label>{t("profile.email")}</Form.Label>
            <Form.Control
              type="email"
              placeholder="user@sophyapp.com"
              value={mail}
              pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"
              required
              autoFocus
              onChange={(e) => setMail(e.target.value)}
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button className="bs-button-color" type="submit">
            {t("mails.send")}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}

export default ResetPasswordModal;